import { defineStore } from "pinia";

import { RecruitmentCandidatesService } from "@core/services";
import {
  PermanentCandidateContactedModel,
  PermanentCandidateIgnoredModel,
  PermanentCandidateModel,
  PermanentCandidateRecruitedModel,
  FeedbackCandidateModel,
  ReportCandidateReasonModel,
} from "@core/models";
import {
  ACTION_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED,
  ACTION_RECRUITMENT_CANDIDATES_GET_REPORT_REASONS,
  ACTION_RECRUITMENT_CANDIDATES_GET_APPLIED,
  ACTION_RECRUITMENT_CANDIDATES_GET_IGNORED,
  ACTION_RECRUITMENT_CANDIDATES_GET_CONTACTED,
  ACTION_RECRUITMENT_CANDIDATES_GET_RECRUITED,
  GETTER_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED,
  GETTER_RECRUITMENT_CANDIDATES_GET_APPLIED,
  GETTER_RECRUITMENT_CANDIDATES_GET_CONTACTED,
  GETTER_RECRUITMENT_CANDIDATES_GET_RECRUITED,
  GETTER_RECRUITMENT_CANDIDATES_GET_IGNORED,
  GETTER_RECRUITMENT_CANDIDATES_GET_REPORT_REASONS,
} from "@etab/stores/types";
import { PERMANENT_CANDIDATES_STATUS } from "@core/constants";

export const useRecruitmentCandidatesStore = defineStore("recruitmentCandidates", {
  // convert to a function
  state: () => ({
    demandContacted: [],
    applied: [],
    contacted: [],
    recruited: [],
    ignored: [],
    reportReasons: [],
  }),
  getters: {
    [GETTER_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED]: (state) => state.demandContacted?.map((candidate) => new FeedbackCandidateModel(candidate)),
    [GETTER_RECRUITMENT_CANDIDATES_GET_APPLIED]: (state) => state.applied?.map((candidate) => new PermanentCandidateModel(candidate)),
    [GETTER_RECRUITMENT_CANDIDATES_GET_CONTACTED]: (state) => state.contacted?.map((candidate) => new PermanentCandidateContactedModel(candidate)),
    [GETTER_RECRUITMENT_CANDIDATES_GET_RECRUITED]: (state) => state.recruited?.map((candidate) => new PermanentCandidateRecruitedModel(candidate)),
    [GETTER_RECRUITMENT_CANDIDATES_GET_IGNORED]: (state) => state.ignored?.map((candidate) => new PermanentCandidateIgnoredModel(candidate)),
    [GETTER_RECRUITMENT_CANDIDATES_GET_REPORT_REASONS]: (state) => state.reportReasons?.map((candidate) => new ReportCandidateReasonModel(candidate)),
  },
  actions: {
    async [ACTION_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED]({ demandId }) {
      const candidates = await RecruitmentCandidatesService.getExpiredRecruitmentCandidates({
        demandId,
      });
      this.demandContacted = candidates;
    },
    async [ACTION_RECRUITMENT_CANDIDATES_GET_APPLIED]({ demandId, type, query }) {
      const candidates = await RecruitmentCandidatesService.getRecruitmentCandidates({
        demandId,
        type,
        status: PERMANENT_CANDIDATES_STATUS.APPLIED,
        query,
      });
      this.applied = candidates;
    },
    async [ACTION_RECRUITMENT_CANDIDATES_GET_CONTACTED]({ demandId, type }) {
      const candidates = await RecruitmentCandidatesService.getRecruitmentCandidates({
        demandId,
        type,
        status: PERMANENT_CANDIDATES_STATUS.CONTACTED,
      });
      this.contacted = candidates;
    },
    async [ACTION_RECRUITMENT_CANDIDATES_GET_RECRUITED]({ demandId, type }) {
      const candidates = await RecruitmentCandidatesService.getRecruitmentCandidates({
        demandId,
        type,
        status: PERMANENT_CANDIDATES_STATUS.RECRUITED,
      });
      this.recruited = candidates;
    },
    async [ACTION_RECRUITMENT_CANDIDATES_GET_IGNORED]({ demandId, type }) {
      const candidates = await RecruitmentCandidatesService.getRecruitmentCandidates({
        demandId,
        type,
        status: PERMANENT_CANDIDATES_STATUS.IGNORED,
      });
      this.ignored = candidates;
    },
    async [ACTION_RECRUITMENT_CANDIDATES_GET_REPORT_REASONS]() {
      if (this.reportReasons?.length === 0) {
        const reasons = await RecruitmentCandidatesService.getReportCandidateReasons();
        this.reportReasons = reasons;
      }
    },
    // easily reset state using `$reset`
    clearRecruitmentCandidatesStore() {
      this.$reset();
    },
  },
});
